"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("../Api"));
const Auth_1 = __importDefault(require("./Auth"));
const Category_1 = __importDefault(require("./Category"));
const Menu_1 = __importDefault(require("./Menu"));
const Device_1 = __importDefault(require("./Device"));
const Merchant_1 = __importDefault(require("./Merchant"));
const MerchantPrinter_1 = __importDefault(require("./MerchantPrinter"));
const Order_1 = __importDefault(require("./Order"));
const Modifier_1 = __importDefault(require("./Modifier"));
const Department_1 = __importDefault(require("./Department"));
const CustomReason_1 = __importDefault(require("./CustomReason"));
class OrderappMerchantApi extends Api_1.default {
    constructor(baseUrlGo, baseUrlNode, configs = { locale: 'zh', appVersion: '' }) {
        super(baseUrlGo, baseUrlNode, configs);
        this.auth = new Auth_1.default(this);
        this.category = new Category_1.default(this);
        this.menu = new Menu_1.default(this);
        this.merchant = new Merchant_1.default(this);
        this.merchantPrinter = new MerchantPrinter_1.default(this);
        this.order = new Order_1.default(this);
        this.modifier = new Modifier_1.default(this);
        this.department = new Department_1.default(this);
        this.customReason = new CustomReason_1.default(this);
        this.device = new Device_1.default(this);
    }
}
exports.default = OrderappMerchantApi;
//# sourceMappingURL=index.js.map